import { Pipe, PipeTransform } from '@angular/core';
import { ChangeOrder } from '../../domains/change-orders/change-order/change-order.model';
import { totalDeductions } from './total-price.pipe';

/**
 * Whole units of the line that the line's accepted deductions use up: the deductions' total, divided by the line's
 * price, rounded DOWN. What is left over (less than one unit's price) comes off the invoice in money
 * (calculateExcessOfDeductionTotal), and the server subtracts the deductions themselves.
 *
 * It used to round each deduction UP, so a $50 deduction on a 1 unit, $350 line used up the only unit and the
 * installer had nothing left to invoice although $300 was owed (5880 VA Leavenworth, Ben 10/20).
 */
export const totalNormalizedUnits = (changeOrders: ChangeOrder[] | undefined, pricePerUnit: number): number =>
  changeOrders?.length && pricePerUnit > 0
    ? Math.floor(+(totalDeductions(changeOrders) / pricePerUnit).toFixed(6))
    : 0;

@Pipe({
  name: 'totalNormalizedUnits',
})
export class TotalNormalizedUnitsPipe implements PipeTransform {
  transform(changeOrders: ChangeOrder[], pricePerUnit: number): number {
    return totalNormalizedUnits(changeOrders, pricePerUnit);
  }
}
